
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';
import moment from 'moment';

//```import constants types
import {
    SYSTEM_ALT_LOG_CONTACTS_REQUEST
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { systemAlertContacsResult } from 'Redux/actions';


function* getSystemAlertLogsMessages({ payload }) {
    try {

        let { id, start, end } = payload?.data;
        
        const QUERY = `
            query searchMessageOutbox ($searchBy: enumMessageOutboxSearchBy!, $entityName: enumEntityName, $entityId: String, $dateRange: AWSDateTimeRange, $limit: Int, $nextToken: String, $lastRecords: Int) {
                result: searchMessageOutbox (searchBy: $searchBy, entityName: $entityName, entityId: $entityId, dateRange: $dateRange, limit: $limit, nextToken: $nextToken, lastRecords: $lastRecords) {
                    items {
                        id
                        targetEntityName
                        targetEntityId
                        to
                        message
                        description
                        status
                        createdOn
                        createdBy
                        updatedOn
                        updatedBy
                    }
                    nextToken
                }
            }
        `;
        let startDate = moment(moment(start).format("YYYY-MM-DD") + " 00:00:00").utc().format("YYYY-MM-DDTHH:mm:ss.sss") + "Z"
        let endDate = moment(moment(end).format("YYYY-MM-DD") + " 23:59:59").utc().format("YYYY-MM-DDTHH:mm:ss.sss") + "Z"

        let data = yield call(
            clientQuery,
            QUERY,
            {
                searchBy: "SourceEntityNameId",
                entityName: "SystemAlertLog",
                entityId: id,
                dateRange: {
                    start: startDate,
                    end: endDate
                },
                limit: 20,
                nextToken: ""
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(systemAlertContacsResult(data?.result))
        } else {
            yield put(systemAlertContacsResult({ error: true }))
        }

    } catch (exc) {
        yield put(systemAlertContacsResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/accounts/.components/systemalertLogsTab/.components/contacts/redux/saga",
            "getSystemAlertLogsMessages",
        )
    }
}

function* watchMethods() {
    yield takeEvery(SYSTEM_ALT_LOG_CONTACTS_REQUEST, getSystemAlertLogsMessages);

}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}